import axios from 'axios';

import { COMMON_BASE_URL } from './constant';
import sha256 from 'crypto-js/sha256';
import { isType } from "../utils";

axios.defaults.baseURL = COMMON_BASE_URL;

axios.defaults.withCredentials = true;

/**
 * jsonp跨域
 * @param {String} url [请求地址]
 * @param {Object} params [请求携带参数]
 */
// axios.jsonp = (url, params) => {
//     if (!url) {
//         console.error('至少需要一个url参数!')
//         return
//     }
//     return new Promise((resolve, reject) => {
//         window.jsonCallBack = (result) => {
//             resolve(result)
//         }
//         const JSONP = document.createElement('script')
//         JSONP.type = 'text/javascript'
//         JSONP.src = `${url}${url.indexOf('?') >= 0 ? '' : '?'}${Qs.stringify(params)}&callback=jsonCallBack`;
//         document.getElementsByTagName('head')[0].appendChild(JSONP)
//         setTimeout(() => {
//             document.getElementsByTagName('head')[0].removeChild(JSONP)
//         }, 500)
//     })
// }

axios.jsonp = (url, data, fn) => {
    if (!url) throw new Error('url is necessary')
    const callback = fn ? fn : 'CALLBACK' + Math.random().toString().substring(9, 28)
    const JSONP = document.createElement('script')
    JSONP.setAttribute('type', 'text/javascript')

    const headEle = document.getElementsByTagName('head')[0]

    let ret = '';
    if (data) {
        if (typeof data === 'string')
            ret = '&' + data;
        else if (typeof data === 'object') {
            for (let key in data) {
                ret += '&' + key + '=' + encodeURIComponent(data[key]);
            }
        }
        ret += '&_time=' + Date.now();
    }

    JSONP.src = `${url}?callback=${callback}${ret}`;
    return new Promise((resolve, reject) => {
        window[callback] = r => {
            resolve(r)
            headEle.removeChild(JSONP)
            delete window[callback]
        }
        headEle.appendChild(JSONP)
    })
}


/**
 * 请求拦截器
 */
axios.interceptors.request.use((config) => {
    return config;
}, (err) => {
    return Promise.reject(err);
});

/**
 * 响应拦截器
 */
axios.interceptors.response.use((response) => {
    return response.data;
}, (err) => {
    return Promise.reject(err);
})

// export get and post methods
export const get = (url = '', params = {}) => {
    return axios.get(url, params, {
        withCredentials: true,
    });
}

export const post = (url = '', params = {}) => {
    return axios.post(url, params, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const postParams = async (url = '', params = {}, config = {}) => {
    const { isSigned = false } = config;
    let { functionId, appid, client, body } = params;
    // 接口加固
    const ps = window.ParamsSign ? new window.ParamsSign({
        appId: 'ae55c',
        preRequest: true,
    }) : null;
    const paramsSign = {
        functionId,
        appid,
        client,
        body: isType(body, 'Object') ? sha256(JSON.stringify(body)).toString() : sha256(body).toString(), //color网关body参数需要业务方进行sha256加密
    };
    if (isSigned) {
        const psSignedObj = ps && ps.sign ? await ps.sign(paramsSign) : {};
        params.h5st = psSignedObj.h5st ? psSignedObj.h5st : null;
        params["x-api-eid-token"] = window.jsToken
    }
    return axios({
        url,
        params,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        },
    })
}

/**
 * 接口方法
 * @param {String} url [请求地址]
 * @param {Object} params [请求携带参数]
 */
export const getJsonp = function (url, params, fn) {
    return new Promise((resolve, reject) => {
        axios
            .jsonp(url, params, fn)
            .then(res => {
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
    })
}
